import React, { useState, useEffect } from "react";
import "./Styles/AllEvents.css";
import { PopupModal } from "../Components";
import axiosConfig from "../Service/axiosConfig";
import Select from "react-select";
import { useParams, useNavigate } from "react-router-dom";
import { FileManager } from "../Components/FileManager/FileManager";
import { AiOutlinePlusCircle } from "react-icons/ai";
import useDebouncedValue from "../Utils/Debounce";
import { RxCross2 } from "react-icons/rx";
import { ReactQuillComponent } from "../Components/FormParser/reactquill/reactquill";
const AddNewEvent = () => {
  let { eventId } = useParams();
  const [selectedImage, setSelectedImage] = useState(null);
  const [popupType, setpopupType] = useState("");
  const [message, setMessage] = useState("");
  const [Error, SetError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebouncedValue(searchTerm, 1000);
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [speakerOptions, setSpeakerOptions] = useState([]);
  const [sponserOptions, setSponserOptions] = useState([]);
  const [organizerOptions, setOrganzerOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [RowPerPage, setRowPerPage] = useState(30);
  const [data, setData] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [fileType, setFileType] = useState("");
  const [formData, setFormData] = useState({
    event_title: "",
    category: "",
    event_description: "",
    start_datetime: "",
    speakers: [],
    sponsors: [],
    organizers: [],
    event_duration: "",
    registration_fee: "",
    total_seats: "",
    thumbnail: "",
    posters: [],
    end_datetime: "",
    who_can_participate: "",
    what_you_can_expect: "",
    online_link: "",
    event_type: "",
    latitude: "",
    longitude: "",
    landmark: "",
    address: "",
    event_link: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const HandleselectChange = (selectedOption, name) => {
    console.log(selectedOption, name);
    setFormData({
      ...formData,
      [name]: selectedOption?.value,
    });
  };
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosConfig.get(`/catlog/categories/`);
        setCategoryOptions(response.data.results);
      } catch (error) {
        console.log(error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchOrganizers = async () => {
      try {
        const response = await axiosConfig.get(`/accounts/organizer/`);
        setOrganzerOptions(response.data.results);
      } catch (error) {
        console.log(error);
      }
    };
    fetchOrganizers();
  }, []);


  useEffect(() => {
    const fetchSpeakers = async () => {
      try {
        const response = await axiosConfig.get(`/accounts/speaker/`);
        setSpeakerOptions(response.data.results);
      } catch (error) {
        console.log(error);
      }
    };
    fetchSpeakers();
  }, []);
  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        const response = await axiosConfig.get(`/accounts/sponsor/`);
        setSponserOptions(response.data.results);
      } catch (error) {
        console.log(error);
      }
    };
    fetchSponsors();
  }, []);



  useEffect(() => {
    if (eventId) {
      GetEvents();
    }
  }, [eventId, currentPage, RowPerPage, debouncedSearchTerm]);

  const GetEvents = async () => {
    setLoading(true);
    try {
      if (!eventId) return;
      const response = await axiosConfig.get(`/accounts/event/${eventId}/`);
      const event = response.data;
      console.log(event, "eve");
      setFormData({
        event_title: event.event_title || "",
        category: event.category?.id || "",
        event_description: event.event_description || "",
        start_datetime: event.start_datetime?.replace(" ", "T").slice(0, 16) || "", // format for datetime-local input
        end_datetime: event.end_datetime?.replace(" ", "T").slice(0, 16) || "",
        // speakersData: event.speakers || [],
        // sponsorsData: event.sponsors || [],
        speakers: event.speakers?.map((speaker) => speaker.id) || [],
        sponsors: event.sponsors?.map((sponsor) => sponsor.id) || [],
        organizers: event.organizers?.map((organizer) => organizer.id) || [],
        event_duration: event.event_duration || "",
        registration_fee: event.registration_fee || "",
        total_seats: event.total_seats || "",
        thumbnail: event.thumbnail || null,
        posters: event.posters || [],
        who_can_participate: event.who_can_participate || "",
        what_you_can_expect: event.what_you_can_expect || "",
        online_link: event.online_link || "",
        event_type: event.event_type || "",
        latitude: event.venue?.latitude || "",
        landmark: event.venue?.landmark || "",
        longitude: event.venue?.longitude || "",
        address: event.venue?.address || "",
        event_link: event.event_link || "",
      });

      setData(event?.results || []);
      setTotalRows(response.data?.count || 0);
    } catch (error) {
      console.error(error);
      SetError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  const formSubmit = (event) => {
    console.log(formData, "inside formSubmit");

    let data = [];
    event.preventDefault();
    const formDataToSend = new FormData();
    if (!formData.category) {
      delete formData.category;
    }
    if (!formData.speakers) {
      delete formData.speakers;
    }
    if (!formData.sponsors) {
      delete formData.sponsors;
    }
    if (!formData.organizers) {
      delete formData.organizers;
    }
    console.log(formDataToSend, "formdatasend");
    formDataToSend.append("event_title", formData.event_title);
    formDataToSend.append("event_description", formData.event_description);
    formDataToSend.append("event_duration", formData.event_duration);
    formDataToSend.append("registration_fee", formData.registration_fee || 0);
    formDataToSend.append("total_seats", formData.total_seats || 0);
    formDataToSend.append("online_link", formData.online_link);
    formDataToSend.append("event_type", formData.event_type);
    if (formData.speakers && Array.isArray(formData.speakers)) {
      formData.speakers.forEach((speaker) => {
        formDataToSend.append("speakers", speaker);
      });
    }

    if (formData.sponsors && Array.isArray(formData.sponsors)) {
      formData.sponsors.forEach((sponser) => {
        formDataToSend.append("sponsors", sponser);
      });
    }

    if (formData.organizers && Array.isArray(formData.organizers)) {
      formData.organizers.forEach((organizer) => {
        formDataToSend.append("organizers", organizer);
      });
    }
    formDataToSend.append("start_datetime", formData.start_datetime);
    formDataToSend.append("end_datetime", formData.end_datetime);
    formDataToSend.append("category", formData.category);
    formDataToSend.append("who_can_participate", formData.who_can_participate);
    formDataToSend.append("what_you_can_expect", formData.what_you_can_expect);

    formDataToSend.append("latitude", formData.latitude);
    formDataToSend.append("longitude", formData.longitude);
    formDataToSend.append("landmark", formData.landmark);
    formDataToSend.append("address", formData.address);
    formDataToSend.append("event_link", formData.event_link);
    // if (formData.posters && formData.posters.length > 0) {
    //   let data = formData.posters.map((image) => image.id);
    //   formDataToSend.append("posters", JSON.stringify(data || []));
    // }
    if (formData.posters && formData.posters.length > 0) {
      formData.posters.map((image) => {
        formDataToSend.append("posters", Number(image.id)); // Make sure it's a number
      });
    }
    // if (formData.thumbnail && formData.thumbnail.length > 0) {
    //   formData.thumbnail.map((image) => {
    //     formDataToSend.append("thumbnail", Number(image.id)); // Make sure it's a number
    //   });
    // }
    if (formData.thumbnail && formData.thumbnail.id) {
      console.log("Sending Thumbnail ID:", formData.thumbnail?.id);
      formDataToSend.append("thumbnail", Number(formData.thumbnail.id));
    }
    axiosConfig.defaults.headers["Content-Type"] = "multipart/form-data";
    console.log(formData, "formdatasend");
    if (eventId) {
      console.log(formDataToSend, "inside form submit");
      axiosConfig
        .patch(`/accounts/event/${eventId}/`, formDataToSend)
        .then((res) => {
          console.log(res);
          setMessage("Event Updated Successfully");

          setpopupType("success");
          SetError("");
        })

        .catch((error) => {
          let errorData = {};
          if (error.response.data.error) {
            SetError(error.response.data.error);
          }

          setpopupType("error");
        });
    } else {
      axiosConfig
        .post(`/accounts/event/`, formDataToSend)
        .then((res) => {
          console.log(res);
          setMessage("Event Created Successfully");
          setpopupType("success");
          SetError("");
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.error) {
            SetError(error.response.data.error);
          }

          if (error.response.data?.posters?.[0]) {
            SetError("images must be a non-empty .");
          }
          setpopupType("error");
        });
    }
  };
  console.log(formData, "kk");

  const openFileManager = (type) => () => {
    setModalShow(true);
    setFileType(type);
  };

  const handleFileSelect = (selectedImages) => {
    console.log("🔔 handleFileSelect triggered:", selectedImages);
    const selected = selectedImages[0];
    console.log("Selected:", selected);
    if (fileType === "thumbnail") {
      setFormData((prev) => ({
        ...prev,
        thumbnail: {
          id: selected?.id,
          image: selected?.image,
          name: selected?.name,
        },
      }));
    } else if (fileType === "posters") {
      setFormData((prev) => ({
        ...prev,
        posters: [...prev.posters, ...selectedImages],
      }));
    }

    setModalShow(false);
  };

  const handleMultiSelectChange = (selectedOptions, field) => {
    const selectedIds = selectedOptions.map((opt) => opt.value);
    setFormData((prev) => ({
      ...prev,
      [field]: selectedIds,
    }));
  };

  const removeImageByIndex = (indexToRemove) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      posters: prevFormData.posters.filter(
        (_, index) => index !== indexToRemove
      ),
    }));
  };
  let navigate = useNavigate();
  const HandleNavigate = () => {
    navigate(-1);
  };

  const Handlefilemanager = () => {
    setModalShow(true);
  };

  const handleImageDragStart = (e, index) => {
    e.dataTransfer.setData("imageIndex", index);
  };

  const handleImageDrop = (e) => {
    e.preventDefault();
    const sourceIndex = e.dataTransfer.getData("imageIndex");
    const destinationIndex = 0;
    const imagesCopy = [...formData.posters];

    // Swap the images
    const temp = imagesCopy[destinationIndex];
    imagesCopy[destinationIndex] = imagesCopy[sourceIndex];
    imagesCopy[sourceIndex] = temp;

    setFormData({
      ...formData,
      posters: imagesCopy,
    });
  };
  console.log(formData);
  return (
    <div className="form-container all-course">
      <h2 className="form-title">Event Details</h2>
      <div className="childnav-content">
        <form onSubmit={(e) => formSubmit(e, null)}>
          <div className="dashboard-header">
            <h5 className="dashboard-subtitle">
              {eventId ? "Edit Item" : "Add Item"}
            </h5>
          </div>
          {Error && (
            <div className="Loginerror">
              <p>{Error}</p>
            </div>
          )}
          <div className="row align-items-center mt-2">
            <div className="col-12">
              <div className="flex-container">
                {formData.posters && formData.posters.length > 0 && (
                  <div className="image-field">
                    <div
                      onDrop={(e) => handleImageDrop(e)}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      <img
                        className="image-item"
                        src={
                          formData.posters[0] && formData.posters[0].image
                            ? formData.posters[0].image
                            : ""
                        }
                        alt={
                          formData.posters[0] && formData.posters[0].image
                            ? formData.posters[0].image
                            : "posters"
                        }
                      />
                    </div>
                  </div>
                )}
                <div className="">
                  {formData.posters && formData.posters.length > 0 && (
                    <div className="image-grid">
                      {formData.posters.map((image, index) => {
                        // Add a null check for 'image' property
                        const imageUrl =
                          image && image.image ? image.image : "";

                        return (
                          <div
                            className="flex-item-image"
                            key={index}
                            draggable
                            onDragStart={(e) => handleImageDragStart(e, index)}
                          >
                            <div>
                              <div className="image-container">
                                <img
                                  src={imageUrl}
                                  alt={`Image ${index + 1}`}
                                  className="grid-item"
                                />
                                <RxCross2
                                  onClick={() => removeImageByIndex(index)}
                                  className="cross-icon"
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  <div>
                    <div
                      className="upload-multiple"
                      onClick={Handlefilemanager}
                    >
                      <div
                        className="upload-plus"
                        onClick={openFileManager("posters")}
                      >
                        <label htmlFor="imageInput1">
                          <AiOutlinePlusCircle className="upload-width" />
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Event Poster</label>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group">
                <label className="form-label">Event Title</label>
                <input
                  type="text"
                  id="event_title"
                  name="event_title"
                  className="form-control"
                  value={formData.event_title}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group">
                <label className="form-label">Thumbnail</label>
                <div
                  onClick={openFileManager("thumbnail")}
                  style={{
                    border: "2px dashed #ccc",
                    borderRadius: "10px",
                    textAlign: "center",
                    padding: "30px",
                    cursor: "pointer",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  {formData.thumbnail ? (
                    <img
                      src={formData.thumbnail?.image}
                      alt="Thumbnail"
                      style={{ maxWidth: "180px", objectFit: "cover" }}
                    />
                  ) : (
                    <div>
                      <div style={{ fontSize: "32px", color: "#6c63ff" }}>
                        📤
                      </div>
                      <div style={{ color: "#6c63ff", fontWeight: "500" }}>
                        Choose a Thumbnail
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group col-12 col-md-6 col-lg-4">
              <label className="form-label">Category</label>
              <Select
                options={categoryOptions.map((res) => ({
                  value: res.id,
                  label: res.name,
                }))}
                placeholder="Category"
                value={categoryOptions
                  .map((res) => ({
                    value: res.id,
                    label: res.name,
                  }))
                  .find((res) => res.value === formData.category)}
                onChange={(selectedOption) => {
                  HandleselectChange(selectedOption, "category");
                }}
                isClearable
              />
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group">
                <label className="form-label">Total seats</label>
                <input
                  type="number"
                  id="total_seats"
                  name="total_seats"
                  className="form-control"
                  value={formData.total_seats}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group">
                <label className="form-label">Registration Fee</label>
                <input
                  type="number"
                  id="registration_fee"
                  name="registration_fee"
                  className="form-control"
                  value={formData.registration_fee}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group">
                <label className="form-label">Event Duration</label>
                <select
                  name="event_duration"
                  id="event_duration"
                  className="form-control"
                  value={formData.event_duration}
                  onChange={(e) => handleFormChange(e)}
                >
                  <option value="Select Duration">Select Duration</option>
                  <option value="Months">Months</option>
                  <option value="Weeks">Weeks</option>
                  <option value="Days">Days</option>
                  <option value="Hours">Hours</option>
                </select>
              </div>
            </div>
            <div className="form-group col-12 col-md-6 col-lg-4">
              <label className="form-label">speakers | Guests</label>
              <Select
                isMulti
                options={speakerOptions.map((res) => ({
                  value: res.id,
                  label: res.user?.full_name || res.full_name,
                }))}
                placeholder="speakers | Guests"
                value={speakerOptions
                  .filter((res) => formData.speakers?.includes(res.id))
                  .map((res) => ({
                    value: res.id,
                    label: res.user?.full_name || res.full_name,
                  }))}
                onChange={(selectedOptions) => {
                  handleMultiSelectChange(selectedOptions, "speakers");
                }}
              />
            </div>
            <div className="form-group col-12 col-md-6 col-lg-4">
              <label className="form-label">Sponsors</label>
              <Select
                isMulti
                options={sponserOptions.map((res) => ({
                  value: res.id,
                  label: res.sponsor_name,
                }))}
                placeholder="Sponsors"
                value={sponserOptions
                  .filter((res) => formData.sponsors?.includes(res.id))
                  .map((res) => ({
                    value: res.id,
                    label: res.sponsor_name,
                  }))}
                onChange={(selectedOptions) => {
                  handleMultiSelectChange(selectedOptions, "sponsors");
                }}
              />
            </div>

            <div className="form-group col-12 col-md-6 col-lg-4">
              <label className="form-label">Organizers</label>
              <Select
                isMulti
                options={organizerOptions.map((res) => ({
                  value: res.id,
                  label: res.name || res.user?.full_name,
                }))}
                placeholder="Organizers"
                value={organizerOptions
                  .filter((res) => formData.organizers?.includes(res.id))
                  .map((res) => ({
                    value: res.id,
                    label: res.name || res.user?.full_name,
                  }))}
                onChange={(selectedOptions) => {
                  handleMultiSelectChange(selectedOptions, "organizers");
                }}
              />
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group">
                <label className="form-label">Event Type</label>
                <select
                  name="event_type"
                  id="event_type"
                  className="form-control"
                  value={formData.event_type}
                  onChange={(e) => handleFormChange(e)}
                >
                  <option value="Select Type">Select Type</option>
                  <option value="Online">Online</option>
                  <option value="Offline">Offline</option>
                </select>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group">
                <label className="form-label">Who can Participate</label>
                <textarea
                  type="text"
                  id="who_can_participate"
                  name="who_can_participate"
                  className="form-control"
                  value={formData.who_can_participate}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
            </div>
            <div className="form-group col-12 col-md-6 col-lg-4">
              <label className="form-label">What you can expect</label>
              <textarea
                type="text"
                id="what_you_can_expect"
                name="what_you_can_expect"
                className="form-control"
                value={formData.what_you_can_expect}
                onChange={(e) => handleFormChange(e)}
              />
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group">
                <label className="form-label">Start Date Time</label>
                <input
                  type="datetime-local"
                  id="start_datetime"
                  name="start_datetime"
                  className="form-control"
                  value={formData.start_datetime}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group">
                <label className="form-label">End Date Time</label>
                <input
                  type="datetime-local"
                  id="end_datetime"
                  name="end_datetime"
                  className="form-control"
                  value={formData.end_datetime}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
            </div>

            {formData.event_type === "Offline" ? (
              <>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group">
                    <label className="form-label">Latitude</label>
                    <input
                      type="text"
                      name="latitude"
                      className="form-control"
                      value={formData.latitude || ""}
                      onChange={(e) => handleFormChange(e)}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group">
                    <label className="form-label">Longitude</label>
                    <input
                      type="text"
                      name="longitude"
                      className="form-control"
                      value={formData.longitude || ""}
                      onChange={(e) => handleFormChange(e)}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group">
                    <label className="form-label">Landmark</label>
                    <input
                      type="text"
                      name="landmark"
                      className="form-control"
                      value={formData.landmark || ""}
                      onChange={(e) => handleFormChange(e)}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">Address</label>
                    <textarea
                      name="address"
                      className="form-control"
                      rows="3"
                      value={formData.address || ""}
                      onChange={(e) => handleFormChange(e)}
                    ></textarea>
                  </div>
                </div>
              </>
            ) : (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="form-group">
                  <label className="form-label">Online Link</label>
                  <input
                    type="text"
                    id="online_link"
                    name="online_link"
                    className="form-control"
                    value={formData.online_link}
                    onChange={(e) => handleFormChange(e)}
                  />
                </div>
              </div>
            )}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="form-group">
                <label className="form-label">Event Link</label>
                <input
                  type="text"
                  id="event_link"
                  name="event_link"
                  className="form-control"
                  value={formData.event_link}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label className="form-label">Event Description</label>
              {/* <input
                type="text"
                id="event_description"
                name="event_description"
                className="form-control"
                value={formData.event_description}
                onChange={(e) => handleFormChange(e)}
              /> */}
              <ReactQuillComponent
                SetData={setFormData}
                Data={formData}
                name="event_description"
                value={formData.event_description}
              />
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <div className="mx-4">
              <button
                type="submit"
                className="btn btn btn-white"
                onClick={HandleNavigate}
              >
                Cancel
              </button>
            </div>
            <div>
              <button type="submit" className="btn btn btn-primary">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>

      {popupType != "" && (
        <PopupModal
          setpopupType={setpopupType}
          popupType={popupType}
          Message={message}
          Navigation={-1}
          error={Error}
        />
      )}
      {modalShow && (
        <FileManager
          modalShow={modalShow}
          setModalShow={setModalShow}
          setFormData={setFormData}
          formData={formData}
          ismultiple={fileType === "posters" ? true : false}
          value={fileType}
          file_name={fileType === "thumbnail" ? "thumbnail" : "posters"}
          handleFile={handleFileSelect}
        />
      )}
    </div>
  );
};
export { AddNewEvent };
// import React, { useState, useEffect } from "react";
// import "./Styles/AllEvents.css";
// import { PopupModal } from "../Components";
// import axiosConfig from "../Service/axiosConfig";
// import Select from "react-select";
// import { useParams, useNavigate } from "react-router-dom";
// import { FileManager } from "../Components/FileManager/FileManager";
// import { AiOutlinePlusCircle } from "react-icons/ai";
// import useDebouncedValue from "../Utils/Debounce";
// import { RxCross2 } from "react-icons/rx";
// import { ReactQuillComponent } from "../Components/FormParser/reactquill/reactquill";
// const AddNewEvent = () => {
//   let { eventId } = useParams();
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [popupType, setpopupType] = useState("");
//   const [showPopup, setShowPopup] = useState(false);
//   const [imageLink, setImageLink] = useState("");
//   const [message, setMessage] = useState("");
//   const [Error, SetError] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const debouncedSearchTerm = useDebouncedValue(searchTerm, 1000);
//   const [loading, setLoading] = useState(false);
//   const [modalShow, setModalShow] = useState(false);
//   const [speakerOptions, setSpeakerOptions] = useState([]);
//   const [sponserOptions, setSponserOptions] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalRows, setTotalRows] = useState(0);
//   const [RowPerPage, setRowPerPage] = useState(30);
//   const [eventResponse, setEventResponse] = useState([]);
//   const [data, setData] = useState([]);
//   const [categoryOptions, setCategoryOptions] = useState([]);
//   const [fileType, setFileType] = useState("");
//   const [formData, setFormData] = useState({
//     event_title: "",
//     category: "",
//     event_description: "",
//     start_datetime: "",
//     speakers: [],
//     sponsors: [],
//     event_duration: "",
//     registration_fee: "",
//     total_seats: "",
//     thumbnail: "",
//     posters: [],
//     end_datetime: "",
//     who_can_participate: "",
//     what_you_can_expect: "",
//     online_link: "",
//     event_type: "",
//     latitude: "",
//     longitude: "",
//     landmark: "",
//     address: "",
//     event_link: "",
//     files: [],
//     youtube_url: [],
//   });
//   const handleChange = (e) => {
//     const files = Array.from(e.target.files);
//     const updatedFiles = files.map((file) => ({
//       image: URL.createObjectURL(file),
//       file,
//     }));

//     setFormData((prev) => ({
//       ...prev,
//       files: [...(prev.files || []), ...updatedFiles],
//     }));
//     setShowPopup(false);
//   };
//   const handleLinkUpload = () => {
//     if (!imageLink) return;

//     const newFile = {
//       image: imageLink,
//       fromLink: true,
//     };

//     setFormData((prev) => ({
//       ...prev,
//       files: [...(prev.files || []), newFile],
//     }));

//     setImageLink(""); // clear the input
//     setShowPopup(false); // optionally close popup
//   };
//   const handleYoutubeUrlChange = (index, value) => {
//     const updatedUrls = [...formData.youtube_url];
//     updatedUrls[index] = value;
//     setFormData((prev) => ({
//       ...prev,
//       youtube_url: updatedUrls,
//     }));
//   };

//   const handleAddYoutubeUrl = () => {
//     setFormData((prev) => ({
//       ...prev,
//       youtube_url: [...prev.youtube_url, ""],
//     }));
//   };

//   const handleFormChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };
//   const HandleselectChange = (selectedOption, name) => {
//     console.log(selectedOption, name);
//     setFormData({
//       ...formData,
//       [name]: selectedOption?.value,
//     });
//   };
//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const response = await axiosConfig.get("/catlog/categories/");
//         setCategoryOptions(response.data.results);
//       } catch (error) {
//         console.log(error);
//       }
//     };
//     fetchCategories();
//   }, []);
//   useEffect(() => {
//     const fetchSpeakers = async () => {
//       try {
//         const response = await axiosConfig.get("/accounts/speaker/");
//         setSpeakerOptions(response.data.results);
//       } catch (error) {
//         console.log(error);
//       }
//     };
//     fetchSpeakers();
//   }, []);
//   useEffect(() => {
//     const fetchSponsors = async () => {
//       try {
//         const response = await axiosConfig.get("/accounts/sponsor/");
//         setSponserOptions(response.data.results);
//       } catch (error) {
//         console.log(error);
//       }
//     };
//     fetchSponsors();
//   }, []);

//   useEffect(() => {
//     if (eventId) {
//       GetEvents();
//     }
//   }, [eventId, currentPage, RowPerPage, debouncedSearchTerm]);

//   const GetEvents = async () => {
//     setLoading(true);
//     try {
//       if (!eventId) return;
//       const response = await axiosConfig.get(`/accounts/event/${eventId}/`);
//       const event = response.data;
//       setEventResponse(event);
//       console.log(event, "eve");
//       setFormData({
//         event_title: event.event_title || "",
//         category: event.category?.id || "",
//         event_description: event.event_description || "",
//         start_datetime: event.start_datetime?.slice(0, 16) || "", // format for datetime-local input
//         end_datetime: event.end_datetime?.slice(0, 16) || "",
//         speakers: event.speakers.map((speaker) => speaker.id) || [],
//         sponsors: event.sponsors.map((sponsor) => sponsor.id) || [],
//         event_duration: event.event_duration || "",
//         registration_fee: event.registration_fee || "",
//         total_seats: event.total_seats || "",
//         thumbnail: event.thumbnail || null,
//         posters: event.posters || [],
//         who_can_participate: event.who_can_participate || "",
//         what_you_can_expect: event.what_you_can_expect || "",
//         online_link: event.online_link || "",
//         event_type: event.event_type || "",
//         latitude: event.venue?.latitude || "",
//         landmark: event.venue?.landmark || "",
//         longitude: event.venue?.longitude || "",
//         address: event.venue?.address || "",
//         event_link: event.event_link || "",
//         files:
//           event.files
//             ?.filter((item) => item.type === "image")
//             .map((item) => ({
//               image: item.image,
//               type: item.type,
//             })) || [],

//         // youtube_url:
//         //   event.files?.find((file) => file.type === "youtube")?.youtube_url ||
//         //   "",
//         youtube_url:
//           event.files
//             ?.filter((item) => item.type === "youtube")
//             .map((item) => item.youtube_url) || [],
//       });

//       setData(event?.results || []);
//       setTotalRows(response.data?.count || 0);
//     } catch (error) {
//       console.error(error);
//       SetError("An error occurred while fetching data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formSubmit = (event) => {
//     console.log(formData, "inside formSubmit");

//     let data = [];
//     event.preventDefault();
//     const formDataToSend = new FormData();
//     if (!formData.category) {
//       delete formData.category;
//     }
//     if (!formData.speakers) {
//       delete formData.speakers;
//     }
//     if (!formData.sponsors) {
//       delete formData.sponsors;
//     }
//     console.log(formDataToSend, "formdatasend");
//     formDataToSend.append("event_title", formData.event_title);
//     formDataToSend.append("event_description", formData.event_description);
//     formDataToSend.append("event_duration", formData.event_duration);
//     formDataToSend.append("registration_fee", formData.registration_fee || 0);
//     formDataToSend.append("total_seats", formData.total_seats || 0);
//     formDataToSend.append("online_link", formData.online_link);
//     formDataToSend.append("event_type", formData.event_type);
//     if (formData.speakers && Array.isArray(formData.speakers)) {
//       formData.speakers.forEach((speaker) => {
//         formDataToSend.append("speakers", speaker);
//       });
//     }
//     // formDataToSend.append("youtube_url", formData.youtube_url);
//     formDataToSend.append("youtube_url", JSON.stringify(formData.youtube_url));

//     if (formData.sponsors && Array.isArray(formData.sponsors)) {
//       formData.sponsors.forEach((sponser) => {
//         formDataToSend.append("sponsors", sponser);
//       });
//     }
//     formDataToSend.append("start_datetime", formData.start_datetime);
//     formDataToSend.append("end_datetime", formData.end_datetime);
//     formDataToSend.append("category", formData.category);
//     formDataToSend.append("who_can_participate", formData.who_can_participate);
//     formDataToSend.append("what_you_can_expect", formData.what_you_can_expect);
//     formDataToSend.append("latitude", formData.latitude);
//     formDataToSend.append("longitude", formData.longitude);
//     formDataToSend.append("landmark", formData.landmark);
//     formDataToSend.append("address", formData.address);
//     formDataToSend.append("event_link", formData.event_link);
//     if (formData.posters && formData.posters.length > 0) {
//       formData.posters.map((image) => {
//         formDataToSend.append("posters", Number(image.id)); // Make sure it's a number
//       });
//     }

//     if (formData.thumbnail && formData.thumbnail.id) {
//       console.log("Sending Thumbnail ID:", formData.thumbnail?.id);
//       formDataToSend.append("thumbnail", Number(formData.thumbnail.id));
//     }
//     axiosConfig.defaults.headers["Content-Type"] = "multipart/form-data";
//     if (formData.files && Array.isArray(formData.files)) {
//       formData.files.forEach((item) => {
//         if (item.file instanceof File) {
//           // Directly append the File
//           formDataToSend.append("files", item.file);
//         } else if (item.image && typeof item.image === "string") {
//           // Fetch image from URL and convert to Blob, then append
//           fetch(item.image)
//             .then((res) => res.blob())
//             .then((blob) => {
//               const fileName = item.image.split("/").pop().split("?")[0]; // fallback name
//               const file = new File([blob], fileName, { type: blob.type });
//               formDataToSend.append("files", file);
//             })
//             .catch((err) => {
//               console.error("Failed to load image from link:", err);
//             });
//         }
//       });
//     }

//     console.log(formData, "formdatasend");
//     if (eventId) {
//       console.log(formDataToSend, "inside form submit");
//       axiosConfig
//         .patch(`/accounts/event/${eventId}/`, formDataToSend)
//         .then((res) => {
//           console.log(res);
//           setMessage("Event Updated Successfully");

//           setpopupType("success");
//           SetError("");
//         })

//         .catch((error) => {
//           let errorData = {};
//           if (error.response.data.error) {
//             SetError(error.response.data.error);
//           }

//           setpopupType("error");
//         });
//     } else {
//       axiosConfig
//         .post("/accounts/event/", formDataToSend)
//         .then((res) => {
//           console.log(res);
//           setMessage("Event Created Successfully");
//           setpopupType("success");
//           SetError("");
//         })
//         .catch((error) => {
//           console.log(error);
//           if (error.response.data.error) {
//             SetError(error.response.data.error);
//           }

//           if (error.response.data?.posters?.[0]) {
//             SetError("images must be a non-empty .");
//           }
//           setpopupType("error");
//         });
//     }
//   };
//   console.log(formData, "kk");

//   const openFileManager = (type) => () => {
//     setModalShow(true);
//     setFileType(type);
//   };

//   const handleFileSelect = (selectedImages) => {
//     console.log("🔔 handleFileSelect triggered:", selectedImages);
//     const selected = selectedImages[0];
//     console.log("Selected:", selected);
//     if (fileType === "thumbnail") {
//       setFormData((prev) => ({
//         ...prev,
//         thumbnail: {
//           id: selected?.id,
//           image: selected?.image,
//           name: selected?.name,
//         },
//       }));
//     } else if (fileType === "posters") {
//       setFormData((prev) => ({
//         ...prev,
//         posters: [...prev.posters, ...selectedImages],
//       }));
//     }

//     setModalShow(false);
//   };
//   //media-items section only activate end date expires
//   const hasEventEnded = (endDateTime) => {
//     if (!endDateTime) return false;
//     const now = new Date();
//     const end = new Date(endDateTime);
//     return now > end;
//   };

//   const handleMultiSelectChange = (selectedOptions, field) => {
//     const selectedIds = selectedOptions.map((opt) => opt.value);
//     setFormData((prev) => ({
//       ...prev,
//       [field]: selectedIds,
//     }));
//   };

//   const removeImageByIndex = (indexToRemove) => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       posters: prevFormData.posters.filter(
//         (_, index) => index !== indexToRemove
//       ),
//     }));
//   };
//   const removeImageById = async (idToRemove) => {
//     if (!idToRemove) {
//       console.error("Missing image ID to delete");
//       return;
//     }

//     try {
//       await axiosConfig.delete(`/catlog/galleryitems/${idToRemove}/`);
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         files: prevFormData.files.filter((file) => file.id !== idToRemove),
//       }));
//     } catch (error) {
//       console.error("Failed to delete image:", error);
//     }
//   };

//   const removeVideosByIndex = (indexToRemove) => {
//     const updatedUrls = formData.youtube_url.filter(
//       (_, index) => index !== indexToRemove
//     );
//     setFormData({
//       ...formData,
//       youtube_url: updatedUrls,
//     });
//   };

//   // const removeImagesByIndex = async (indexToRemove) => {
//   //   const itemToDelete = eventResponse?.files?.map(
//   //     (file) => file.id === indexToRemove
//   //   );
//   //   console.log(itemToDelete, "image");

//   //   if (!itemToDelete || !itemToDelete.id) {
//   //     console.error("Missing ID in item:", itemToDelete);
//   //     return;
//   //   }

//   //   try {
//   //     await axiosConfig.delete(/catlog/galleryitems/${itemToDelete.id}/);
//   //     setFormData((prevFormData) => ({
//   //       ...prevFormData,
//   //       files: prevFormData.files.filter((_, index) => index !== indexToRemove),
//   //     }));
//   //   } catch (error) {
//   //     console.error("Failed to delete file:", error);
//   //   }
//   // };

//   // const removeVideosByIndex = async (indexToRemove) => {
//   //   const itemToDelete = eventResponse?.files?.map(
//   //     (file) => file.id === indexToRemove
//   //   );
//   //   console.log(itemToDelete, "video");
//   //   if (!itemToDelete || !itemToDelete) {
//   //     console.error("Missing ID in item:", itemToDelete);
//   //     return;
//   //   }
//   //   try {
//   //     await axiosConfig.delete(/catlog/galleryitems/${itemToDelete}/);
//   //     setFormData((prevFormData) => ({
//   //       ...prevFormData,
//   //       youtube_url: prevFormData.youtube_url.filter(
//   //         (_, index) => index !== indexToRemove
//   //       ),
//   //     }));
//   //   } catch (error) {
//   //     console.error("Failed to delete YouTube URL:", error);
//   //   }
//   // };

//   let navigate = useNavigate();
//   const HandleNavigate = () => {
//     navigate(-1);
//   };

//   const Handlefilemanager = () => {
//     setModalShow(true);
//   };

//   const handleImageDragStart = (e, index) => {
//     e.dataTransfer.setData("imageIndex", index);
//   };

//   const handleImageDrop = (e) => {
//     e.preventDefault();
//     const sourceIndex = e.dataTransfer.getData("imageIndex");
//     const destinationIndex = 0;
//     const imagesCopy = [...formData.posters];

//     // Swap the images
//     const temp = imagesCopy[destinationIndex];
//     imagesCopy[destinationIndex] = imagesCopy[sourceIndex];
//     imagesCopy[sourceIndex] = temp;

//     setFormData({
//       ...formData,
//       posters: imagesCopy,
//     });
//   };
//   console.log(formData);
//   return (
//     <div className="form-container all-course">
//       <h2 className="form-title">Event Details</h2>
//       <div className="childnav-content">
//         <form onSubmit={(e) => formSubmit(e, null)}>
//           <div className="dashboard-header">
//             <h5 className="dashboard-subtitle">
//               {eventId ? "Edit Item" : "Add Item"}
//             </h5>
//           </div>
//           {Error && (
//             <div className="Loginerror">
//               <p>{Error}</p>
//             </div>
//           )}
//           <div className="row align-items-center mt-2">
//             <div className="col-6">
//               <div className="form-group">
//                 <label className="form-label">Event Title</label>
//                 <input
//                   type="text"
//                   id="event_title"
//                   name="event_title"
//                   className="form-control"
//                   value={formData.event_title}
//                   onChange={(e) => handleFormChange(e)}
//                 />
//               </div>
//             </div>

//             <div className="form-group col-6">
//               <label className="form-label">Category</label>
//               <Select
//                 options={categoryOptions.map((res) => ({
//                   value: res.id,
//                   label: res.name,
//                 }))}
//                 placeholder="Category"
//                 value={categoryOptions
//                   .map((res) => ({
//                     value: res.id,
//                     label: res.name,
//                   }))
//                   .find((res) => res.value === formData.category)}
//                 onChange={(selectedOption) => {
//                   HandleselectChange(selectedOption, "category");
//                 }}
//                 isClearable
//               />
//             </div>
//             <div className="col-6">
//               <div className="form-group">
//                 <label className="form-label">Event Description</label>
//                 <ReactQuillComponent
//                   SetData={setFormData}
//                   Data={formData}
//                   name="event_description"
//                   value={formData.event_description}
//                 />
//               </div>
//             </div>
//             <div className="col-6">
//               <div className="form-group">
//                 <label className="form-label">Start Date Time</label>
//                 <input
//                   type="datetime-local"
//                   id="start_datetime"
//                   name="start_datetime"
//                   className="form-control"
//                   value={formData.start_datetime}
//                   onChange={(e) => handleFormChange(e)}
//                 />
//               </div>
//             </div>
//             <div className="col-6">
//               <div className="form-group">
//                 <label className="form-label">Event Duration</label>
//                 <select
//                   name="event_duration"
//                   id="event_duration"
//                   className="form-control"
//                   value={formData.event_duration}
//                   onChange={(e) => handleFormChange(e)}
//                 >
//                   <option value="Select Duration">Select Duration</option>
//                   <option value="Months">Months</option>
//                   <option value="Weeks">Weeks</option>
//                   <option value="Days">Days</option>
//                   <option value="Hours">Hours</option>
//                 </select>
//               </div>
//             </div>
//             <div className="col-6">
//               <div className="form-group">
//                 <label className="form-label">Registration Fee</label>
//                 <input
//                   type="number"
//                   id="registration_fee"
//                   name="registration_fee"
//                   className="form-control"
//                   value={formData.registration_fee}
//                   onChange={(e) => handleFormChange(e)}
//                 />
//               </div>
//             </div>
//             <div className="form-group col-6">
//               <label className="form-label">speakers | Guests</label>
//               <Select
//                 isMulti
//                 options={speakerOptions.map((res) => ({
//                   value: res.id,
//                   label: res.full_name,
//                 }))}
//                 placeholder="speakers | Guests"
//                 value={speakerOptions
//                   .filter((res) => formData.speakers.includes(res.id))
//                   .map((res) => ({
//                     value: res.id,
//                     label: res.full_name,
//                   }))}
//                 onChange={(selectedOptions) => {
//                   handleMultiSelectChange(selectedOptions, "speakers");
//                 }}
//               />
//             </div>
//             <div className="col-6">
//               <div className="form-group">
//                 <label className="form-label">Total seats</label>
//                 <input
//                   type="number"
//                   id="total_seats"
//                   name="total_seats"
//                   className="form-control"
//                   value={formData.total_seats}
//                   onChange={(e) => handleFormChange(e)}
//                 />
//               </div>
//             </div>
//             <div className="col-6">
//               <div className="form-group">
//                 <label className="form-label">Thumbnail</label>
//                 <div
//                   onClick={openFileManager("thumbnail")}
//                   style={{
//                     border: "2px dashed #ccc",
//                     borderRadius: "10px",
//                     textAlign: "center",
//                     padding: "30px",
//                     cursor: "pointer",
//                     backgroundColor: "#f9f9f9",
//                   }}
//                 >
//                   {formData.thumbnail ? (
//                     <img
//                       src={formData.thumbnail?.image}
//                       alt="Thumbnail"
//                       style={{ maxWidth: "180px", objectFit: "cover" }}
//                     />
//                   ) : (
//                     <div>
//                       <div style={{ fontSize: "32px", color: "#6c63ff" }}>
//                         📤
//                       </div>
//                       <div style={{ color: "#6c63ff", fontWeight: "500" }}>
//                         Choose a Thumbnail
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div className="col-6">
//               <div className="flex-container">
//                 {formData.posters && formData.posters.length > 0 && (
//                   <div className="image-field">
//                     <div
//                       onDrop={(e) => handleImageDrop(e)}
//                       onDragOver={(e) => e.preventDefault()}
//                     >
//                       <img
//                         className="image-item"
//                         src={
//                           formData.posters[0] && formData.posters[0].image
//                             ? formData.posters[0].image
//                             : ""
//                         }
//                         alt={
//                           formData.posters[0] && formData.posters[0].image
//                             ? formData.posters[0].image
//                             : "posters"
//                         }
//                       />
//                     </div>
//                   </div>
//                 )}
//                 <div className="">
//                   {formData.posters && formData.posters.length > 0 && (
//                     <div className="image-grid">
//                       {formData.posters.map((image, index) => {
//                         // Add a null check for 'image' property
//                         const imageUrl =
//                           image && image.image ? image.image : "";

//                         return (
//                           <div
//                             className="flex-item-image"
//                             key={index}
//                             draggable
//                             onDragStart={(e) => handleImageDragStart(e, index)}
//                           >
//                             <div>
//                               <div className="image-container">
//                                 <img
//                                   src={imageUrl}
//                                   alt={`Image ${index + 1}`}
//                                   className="grid-item"
//                                 />
//                                 <RxCross2
//                                   onClick={() => removeImageByIndex(index)}
//                                   className="cross-icon"
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}

//                   <div>
//                     <div
//                       className="upload-multiple"
//                       onClick={Handlefilemanager}
//                     >
//                       <div
//                         className="upload-plus"
//                         onClick={openFileManager("posters")}
//                       >
//                         <label htmlFor="imageInput1">
//                           <AiOutlinePlusCircle className="upload-width" />
//                         </label>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="form-group">
//                     <label className="form-label">Event Poster</label>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-6">
//               <div className="form-group">
//                 <label className="form-label">End Date Time</label>
//                 <input
//                   type="datetime-local"
//                   id="end_datetime"
//                   name="end_datetime"
//                   className="form-control"
//                   value={formData.end_datetime}
//                   onChange={(e) => handleFormChange(e)}
//                 />
//               </div>
//             </div>
//             <div className="col-6">
//               <div className="form-group">
//                 <label className="form-label">Who can Participate</label>
//                 <textarea
//                   type="text"
//                   id="who_can_participate"
//                   name="who_can_participate"
//                   className="form-control"
//                   value={formData.who_can_participate}
//                   onChange={(e) => handleFormChange(e)}
//                 />
//               </div>
//             </div>
//             <div className="form-group col-6">
//               <label className="form-label">What you can expect</label>
//               <textarea
//                 type="text"
//                 id="what_you_can_expect"
//                 name="what_you_can_expect"
//                 className="form-control"
//                 value={formData.what_you_can_expect}
//                 onChange={(e) => handleFormChange(e)}
//               />
//             </div>
//             <div className="col-6">
//               <div className="form-group">
//                 <label className="form-label">Event Type</label>
//                 <select
//                   name="event_type"
//                   id="event_type"
//                   className="form-control"
//                   value={formData.event_type}
//                   onChange={(e) => handleFormChange(e)}
//                 >
//                   <option value="Select Type">Select Type</option>
//                   <option value="Online">Online</option>
//                   <option value="Offline">Offline</option>
//                 </select>
//               </div>
//             </div>
//             {formData.event_type === "Offline" ? (
//               <>
//                 <div className="col-6">
//                   <div className="form-group">
//                     <label className="form-label">Latitude</label>
//                     <input
//                       type="text"
//                       name="latitude"
//                       className="form-control"
//                       value={formData.latitude || ""}
//                       onChange={(e) => handleFormChange(e)}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-6">
//                   <div className="form-group">
//                     <label className="form-label">Longitude</label>
//                     <input
//                       type="text"
//                       name="longitude"
//                       className="form-control"
//                       value={formData.longitude || ""}
//                       onChange={(e) => handleFormChange(e)}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-6">
//                   <div className="form-group">
//                     <label className="form-label">Landmark</label>
//                     <input
//                       type="text"
//                       name="landmark"
//                       className="form-control"
//                       value={formData.landmark || ""}
//                       onChange={(e) => handleFormChange(e)}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-6">
//                   <div className="form-group">
//                     <label className="form-label">Address</label>
//                     <textarea
//                       name="address"
//                       className="form-control"
//                       rows="3"
//                       value={formData.address || ""}
//                       onChange={(e) => handleFormChange(e)}
//                     ></textarea>
//                   </div>
//                 </div>
//               </>
//             ) : (
//               <div className="col-6">
//                 <div className="form-group">
//                   <label className="form-label">Online Link</label>
//                   <input
//                     type="text"
//                     id="online_link"
//                     name="online_link"
//                     className="form-control"
//                     value={formData.online_link}
//                     onChange={(e) => handleFormChange(e)}
//                   />
//                 </div>
//               </div>
//             )}
//             <div className="col-4">
//               <div className="form-group">
//                 <label className="form-label">Event Link</label>
//                 <input
//                   type="text"
//                   id="event_link"
//                   name="event_link"
//                   className="form-control"
//                   value={formData.event_link}
//                   onChange={(e) => handleFormChange(e)}
//                 />
//               </div>
//             </div>

//             <div className="form-group col-6">
//               <label className="form-label">Sponsors</label>
//               <Select
//                 isMulti
//                 options={sponserOptions.map((res) => ({
//                   value: res.id,
//                   label: res.sponsor_name,
//                 }))}
//                 placeholder="Sponsors"
//                 value={sponserOptions
//                   .filter((res) => formData.sponsors?.includes(res.id))
//                   .map((res) => ({
//                     value: res.id,
//                     label: res.sponsor_name,
//                   }))}
//                 onChange={(selectedOptions) => {
//                   handleMultiSelectChange(selectedOptions, "sponsors");
//                 }}
//               />
//             </div>
//           </div>

//           <h2 className="form-title">Post Event Insights</h2>
//           <label className="form-label">Upload Images:</label>
//           <div className="d-flex justify-content-center gap-24">
//             <div className="rounded-dots">
//               <div
//                 onClick={() => setShowPopup(true)}
//                 className="upload-trigger"
//               >
//                 <AiOutlinePlusCircle className="upload-width" size={40} />
//               </div>
//             </div>
//             {formData.files && formData.files?.length > 0 && (
//               <div className="image-grids form-group col-6">
//                 {formData.files.map((image, index) => {
//                   const imageUrl = image && image.image ? image.image : "";
//                   return (
//                     <div
//                       className="flex-item-image"
//                       key={index}
//                       draggable
//                       onDragStart={(e) => handleImageDragStart(e, index)}
//                     >
//                       <div>
//                         <div className="image-container">
//                           <img
//                             src={imageUrl}
//                             alt={`Image ${index + 1}`}
//                             className="grid-item"
//                           />
//                           <RxCross2
//                             className="cross-icon"
//                             onClick={() => removeImageByIndex(index)}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             )}
//           </div>

//           <div className="youtube_flex">
//             {formData.youtube_url.map((url, index) => {
//               const videoId = String(url).match(
//                 /(?:youtube\.com.*[?&]v=|youtu\.be\/)([^&?/]+)/i
//               )?.[1];
//               const embedUrl = videoId
//                 ? `https://www.youtube.com/embed/${videoId}`
//                 : null;
//               return (
//                 <div className="row mb-2 align-items-start" key={index}>
//                   <div className="form-group col-5">
//                     <label className="form-label">
//                       YouTube URL {index + 1}
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={url}
//                       onChange={(e) =>
//                         handleYoutubeUrlChange(index, e.target.value)
//                       }
//                     />
//                   </div>
//                   <div className="col-5 image-grids">
//                     {embedUrl ? (
//                       <>
//                         <iframe
//                           width="100%"
//                           height="120"
//                           src={embedUrl}
//                           title={`YouTube Preview ${index + 1}`}
//                           frameBorder="0"
//                           allowFullScreen
//                         />
//                         <RxCross2
//                           onClick={() => removeVideosByIndex(index)}
//                           className="crossfor-icon"
//                         />
//                       </>
//                     ) : (
//                       <p className="text-danger"></p>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//             <button
//               type="button"
//               className="youtube_add btn btn-primary mt-2"
//               onClick={handleAddYoutubeUrl}
//             >
//               + Add YoutubeVideo
//             </button>
//           </div>

//           {showPopup && (
//             <div className="popup-overlay">
//               <div className="popup-container">
//                 <div className="upload-options">
//                   {/* From Device */}
//                   <label className="option">
//                     📁 From Device
//                     <input
//                       type="file"
//                       hidden
//                       multiple
//                       onChange={handleChange}
//                     />
//                   </label>

//                   {/* From Link */}
//                   {/* <div className="option">
//                     🔗 From Link
//                     <input
//                       type="text"
//                       placeholder="Paste image URL"
//                       value={imageLink}
//                       onChange={(e) => setImageLink(e.target.value)}
//                     />
//                     <button onClick={handleLinkUpload}>Upload</button>
//                   </div> */}

//                   {/* Cancel */}
//                   <button
//                     onClick={() => setShowPopup(false)}
//                     className="cancel-btn"
//                   >
//                     Cancel
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           <div className="d-flex justify-content-end">
//             <div className="mx-4">
//               <button
//                 type="submit"
//                 className="btn btn btn-white"
//                 onClick={HandleNavigate}
//               >
//                 Cancel
//               </button>
//             </div>
//             <div>
//               <button type="submit" className="btn btn btn-primary">
//                 Submit
//               </button>
//             </div>
//           </div>
//         </form>
//       </div>

//       {popupType != "" && (
//         <PopupModal
//           setpopupType={setpopupType}
//           popupType={popupType}
//           Message={message}
//           Navigation={"/allevent"}
//           error={Error}
//         />
//       )}
//       {modalShow && (
//         <FileManager
//           modalShow={modalShow}
//           setModalShow={setModalShow}
//           setFormData={setFormData}
//           formData={formData}
//           ismultiple={fileType === "posters" ? true : false}
//           value={fileType}
//           file_name={fileType === "thumbnail" ? "thumbnail" : "posters"}
//           handleFile={handleFileSelect}
//         />
//       )}
//     </div>
//   );
// };
// export { AddNewEvent };
